module.exports = __webpack_public_path__ + "img/android-app-icon.c0c5871f.jpg";